import React from 'react';
import '../css/BSSIDsDetails.css'; // 导入样式文件
import { fetchWifiData } from '../data/getdata';
import wifiIcon from '../svg/wifi.svg';
import backIcon from '../svg/back.svg'; // 导入back.svg图标
import APsIcon from '../svg/Aps.svg';
import BSSIDsIcon from '../svg/BSSIDs.svg';
import RateIcon from '../svg/Rate.svg';
import ClientIcon from '../svg/client.svg';
import moreIcon from '../svg/more.svg';

const BssidsDetails = ({ selectedBSSID, otherData, onReturn, onRateClick }) => {
 
  // 打印选中的SSID的详细信息
  console.log(selectedBSSID);
   // 获取选中的SSID的详细信息
  const {
    hidden_state,
    ssid,
    strongestApName,
    signal,
    snr,
    wifi_item: {
      wlan_protocol_set,
      security_type_set,
      last_seen
    }
  } = selectedBSSID;

  // 根据wlan_protocol_set的值确定Wi-Fi支持的协议
  let wifiProtocol = '';
  const protocolMap = {
    128: 'ax',
    32: 'ac',
    16: 'n',
    8: 'g',
    4: 'a',
    2: 'b',
  };
  const protocolOrder = [128, 32, 16, 8, 4, 2];
  
  for (let key of protocolOrder) {
    if (wlan_protocol_set.includes(key)) {
      wifiProtocol += protocolMap[key] + ', ';
    }
  }
  // 移除末尾的逗号和空格
  wifiProtocol = wifiProtocol.trim().replace(/,\s*$/, '');
  
  // 根据securityType的值确定安全类型
  let securityType = '';
  const securityMap = {
    1: 'OPEN',
    8: 'WPA-P',
    32: 'WPA2-P',
    2048: 'WPA3-P',
  };
  
  Object.entries(securityMap)
    .sort(([keyA], [keyB]) => parseInt(keyB) - parseInt(keyA))
    .forEach(([key, value]) => {
      if (security_type_set.includes(parseInt(key))) {
        securityType += value + ', ';
      }
    });
  
  // 移除末尾的逗号和空格
  securityType = securityType.trim().replace(/,\s*$/, '');
  

  // 将时间戳转换为格式化的上午/下午时间字符串
  const formatLastSeenTime = (timestamp) => {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? '下午' : '上午';
    hours = hours % 12;
    hours = hours ? hours : 12; // 如果是0，则显示12
    const formattedTime = ampm + ' ' + hours + ':' + minutes + ':' + seconds;
    return formattedTime;
  };

//--------------------根据ID获取匹配的客户端列表--------------------
const getMatchedClients = (selectedBSSID, otherData) => {
  // 确保 selectedBSSID 和 otherData 都存在
  if (!selectedBSSID || !selectedBSSID.wifi_item || !selectedBSSID.wifi_item.clients || !otherData || !otherData.clients) return [];
  
  // 获取当前SSID的客户端列表
  const clients = selectedBSSID.wifi_item.clients;
  
  // 遍历所有客户端并与 otherData 中的匹配
  const matchedClients = clients.filter(client => otherData.clients.find(item => item.wifi_item.id === client));
  
  // 返回匹配的客户端列表
  return matchedClients.map(client => otherData.clients.find(item => item.wifi_item.id === client)?.wifi_host.best_name_formatted).filter(Boolean);
};




    // 获取匹配的客户端列表
    const selectematchedClients = getMatchedClients(selectedBSSID, otherData);
    console.log(selectematchedClients);




  return (
    <div className="ssid-details"> 
    <div className="ssid-details-container">
      <img src={BSSIDsIcon} alt="BSSIDs Logo" className="wifi-icon" />
      <div className="APNAME">{selectedBSSID.wifi_host.long_mfr_mac}</div>
      <div className="APStatust">BSSID</div>
      
      <div className="APStatusttitle">SSID: <a class="APStatusttitle-blue">{selectedBSSID.ssid}</a></div>
      <div className="APStatusttitle">AP: <a class="APStatusttitle-blue">{selectedBSSID.ap_best_name_formatted}</a></div>
      <div className="details">BSSID:{selectedBSSID.wifi_host.long_mfr_mac}</div>
      <div className="APStatusttitle">802.11</div>
      <div className="details">信道:<a className="APStatusttitle-blue"> {selectedBSSID.wifi_host.channel} ({ selectedBSSID.apData.channel_width === 'WLAN_CHANNEL_160_MHZ' ? '160MHz':  selectedBSSID.apData.channel_width === 'WLAN_CHANNEL_80_MHZ' ? '80MHz' : selectedBSSID.apData.channel_width === 'WLAN_CHANNEL_40_MHZ' ? '40MHz' : selectedBSSID.apData.channel_width === 'WLAN_CHANNEL_20_MHZ' ? '20MHz' : selectedBSSID.apData.channel_width}, {selectedBSSID.apData.channel_lower}-{selectedBSSID.apData.channel_upper})</a></div>
      <div className="details">类型: {wifiProtocol }</div>
      <div className="details">信号: {selectedBSSID.wifi_host.signal}dBm</div>
      <div className="details">SNR: {selectedBSSID.wifi_host.snr} dB</div>
      <div className="details">Tx Power: {selectedBSSID.apData.beacon_tx_power_dbm}dBm</div>
      <div className="details">QBSS 站点数: {selectedBSSID.apData.qbss_station_count}</div>
      <div className="details">安全类型： {securityType}</div>
      <div className="formatLastSeenTime">上次看到: {formatLastSeenTime(last_seen)}</div>
      <img className="back-button" src={backIcon} alt="Back" onClick={onReturn} />
      </div>


      <div className="additional-details-box-clients" onClick={onRateClick}>
        <img src={RateIcon} alt="Rate Logo" className="rate-icon" />
        <img src={moreIcon} alt="More-clients" className="more-icon-clients" />
        <div className="Title-clients">速率和性能</div>
      </div>


      <div className="additional-details-box-clients">
        <img src={ClientIcon} alt="Client Logo" className="wifi-icon" />
        <img src={moreIcon} alt="More-clients" className="more-icon-clients" />
        <div className="Title-clients">客户端</div>
        <div className="count-clients">{selectedBSSID.wifi_item.clients ? selectedBSSID.wifi_item.clients.length : 0}</div>
      </div>
    </div>
      
      

  );
};

export default BssidsDetails;
